import './RunningApplicationWarning.css';

import React, { type FC } from 'react';
import { Spinner } from '@src/components';

export const RunningApplicationWarning: FC = () => (
  <div id="running_application_warning_modal">
    <div id="running_application_warning_container">
      <Spinner spinnerText={'An application is running'}/>
      <div id="running_application_warning">
        Wait for the application to complete before editing the configuration.
      </div>
    </div>
  </div>
);
